var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-3",class:{
    'd-none':
      (!_vm.item.apply_new_rule && _vm.item.displayOn && !_vm.display_none_check) ||
      (!_vm.item.apply_new_rule && _vm.item.displayOn2 && !_vm.display_none_check2) ||
      (!_vm.item.apply_new_rule && _vm.item.displayOn3 && !_vm.display_none_check3),
  }},[(!_vm.item.hideLabel)?_c('Label',{attrs:{"item":_vm.item,"model_length":_vm.validation.$model.length}}):_vm._e(),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],staticClass:"form-control",class:{
      'is-invalid': _vm.submitted && _vm.validation.$error,
      'bg-soft-secondary':
        _vm.item.disableOn && _vm.disable_check
          ? true
          : this.$route.params.categoryName == 'globalupdate'
          ? false
          : _vm.selectedItem &&
            _vm.selectedItem.additionalProp1 &&
            _vm.selectedItem.additionalProp1.global
          ? true
          : _vm.item.disabled
          ? true
          : false,
    },attrs:{"max":_vm.max_char_count,"maxlength":_vm.max_char_count,"type":"text","disabled":_vm.item.disableOn && _vm.disable_check
        ? true
        : this.$route.params.categoryName == 'globalupdate'
        ? false
        : _vm.selectedItem &&
          _vm.selectedItem.additionalProp1 &&
          _vm.selectedItem.additionalProp1.global
        ? true
        : _vm.item.disabled
        ? true
        : false,"placeholder":_vm.item.placeholder},domProps:{"value":(_vm.value)},on:{"input":function($event){if($event.target.composing)return;_vm.value=$event.target.value}}}),(_vm.submitted && _vm.validation.$error)?_c('div',{staticClass:"invalid-feedback"},[(!_vm.validation.required)?_c('span',[_vm._v("This value is required.")]):_vm._e()]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }